import { ACTION_TYPE, fetchJson } from '../../store/actionCreatorsHelpers';

interface Payload {
    appDefinitionFile?: File;
    sideloadedAppDefinition?: File;
}

export function loadAppDefinition({ appDefinitionFile }: Payload) {
    return {
        type: ACTION_TYPE.LOAD_APP_DEFINITION,
        appDefinitionFile,
    };
}

export function addSideloadedApp({ sideloadedAppDefinition }: Payload) {
    return {
        type: ACTION_TYPE.ADD_SIDELOADED_APP,
        payload: fetchJson('api/sideload', {
            method: 'POST',
            body: sideloadedAppDefinition,
        }),
    };
}

export function closeSideloadedAppModal() {
    return {
        type: ACTION_TYPE.CLOSE_SIDELOADED_APP_MODAL,
    };
}

export function openSideloadedAppModal() {
    return {
        type: ACTION_TYPE.OPEN_SIDELOADED_APP_MODAL,
    };
}
